// Capture the bearer token before Firebase, App Check or analytics initializes.
// Remove it from the address bar; session storage keeps reloads working in this tab.
let capturedToken = "";
export function captureCipcApprovalToken() {
  if (typeof window === "undefined" || window.location.pathname !== "/CipcApproval") return "";
  const incoming = new URLSearchParams(window.location.hash.slice(1)).get("token");
  if (incoming) {
    capturedToken = incoming;
    try { window.sessionStorage.setItem("cipcApprovalToken", incoming); } catch { /* This tab can still use the in-memory token. */ }
    window.history.replaceState(window.history.state, "", window.location.pathname);
  } else if (!capturedToken) {
    try { capturedToken = window.sessionStorage.getItem("cipcApprovalToken") || ""; } catch { /* Ask for a fresh link if reload storage is unavailable. */ }
  }
  return capturedToken;
}
